var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", md12: "" } },
        [
          _c(
            "v-layout",
            {
              staticClass: "px-3 pt-2 text-xs-center",
              attrs: { row: "", wrap: "" }
            },
            [
              _c(
                "v-flex",
                { staticClass: "text-xs-left", attrs: { xs5: "", md3: "" } },
                [
                  _c(
                    "v-layout",
                    { staticClass: "text-xs-center", attrs: { row: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "condition__item" },
                        [
                          _c("h4", { staticClass: "mb-2 text-xs-left" }, [
                            _vm._v(
                              _vm._s(_vm.$t(_vm.lblSetting.profileFilterBy))
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.coFiltersLoader
                            ? _c("base-multi-select", {
                                attrs: {
                                  options: _vm.dtRolesFilters,
                                  "return-object": false,
                                  multiple: true,
                                  placeholder: "Role...",
                                  "item-text": "text",
                                  "item-value": "id"
                                },
                                model: {
                                  value: _vm.role,
                                  callback: function($$v) {
                                    _vm.role = $$v
                                  },
                                  expression: "role"
                                }
                              })
                            : _c("profile-filter-loader")
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.coTableLoader
            ? [
                _vm.$route.meta["delete_team_account"]
                  ? _c(
                      "v-layout",
                      {
                        staticClass: "px-3",
                        attrs: { "justify-end": "", row: "", wrap: "" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "pa-0 ma-0",
                            staticStyle: { "text-transform": "inherit" },
                            style: {
                              visibility: _vm.memberSelection.length
                                ? "visible"
                                : "hidden"
                            },
                            attrs: { text: "", flat: "", color: "#777" },
                            on: { click: _vm.handleDeleteSelection }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "px-1", attrs: { small: "" } },
                              [_vm._v("delete")]
                            ),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(_vm.lblSetting.profileDeleteSelection)
                                ) +
                                "\n              "
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _c(
                "v-layout",
                {
                  staticClass: "px-3",
                  attrs: { "justify-end": "", row: "", wrap: "" }
                },
                [_c("profile-delete-loader")],
                1
              ),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              staticClass: "px-3",
              staticStyle: { "margin-bottom": "50px" },
              attrs: { row: "", wrap: "" }
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "agency__members",
                  attrs: { flat: "", color: "transparent" }
                },
                [
                  _c(
                    "v-data-table",
                    {
                      staticClass:
                        "dr-table--transparent dr-table__profile elevation-2",
                      attrs: {
                        headers: _vm.coHeaders,
                        items: _vm.coMembers,
                        pagination: _vm.pagination,
                        "total-items": _vm.totalItems,
                        loading: _vm.dtIsLoading,
                        "rows-per-page-items": [10, 25, 50],
                        "rows-per-page-text": "Lignes par page",
                        "no-data-text": "Pas de données disponibles"
                      },
                      on: {
                        "update:pagination": function($event) {
                          _vm.pagination = $event
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c(
                                "tr",
                                {
                                  on: {
                                    mouseover: function($event) {
                                      _vm.dtHoveredMember = props.item.id
                                    },
                                    mouseleave: function($event) {
                                      _vm.dtHoveredMember = -1
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "td",
                                    { staticClass: "primary--text" },
                                    [
                                      _c(
                                        "v-avatar",
                                        {
                                          attrs: {
                                            color: _vm.isMemberSelected(
                                              props.item.id
                                            )
                                              ? "#2E038C !important"
                                              : "#eee !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.handleAvatarClick(
                                                props.item.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "headline",
                                              class: {
                                                "white--text": _vm.isMemberSelected(
                                                  props.item.id
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm._f("acronym")(
                                                      props.item.name
                                                    )
                                                  ) +
                                                  "\n                          "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.coTableLoader
                                    ? _c(
                                        "td",
                                        { staticClass: "primary--text" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "primary--text__head"
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(_vm._s(props.item.name))
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "primary--text__sub"
                                            },
                                            [_vm._v(_vm._s(props.item.role))]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "td",
                                        { staticClass: "primary--text" },
                                        [
                                          _c("profile-table-loader", {
                                            attrs: {
                                              "loader-type": "multi-column"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  !_vm.coTableLoader
                                    ? [
                                        _c(
                                          "td",
                                          { staticClass: "primary--text" },
                                          [_vm._v(_vm._s(props.item.email))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "primary--text",
                                            class: {
                                              "empty--column": !props.item
                                                .landline
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.landline || "-")
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "primary--text",
                                            class: {
                                              "empty--column": !props.item
                                                .cellphone
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                props.item.cellphone || "-"
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    : [
                                        _c(
                                          "td",
                                          { staticClass: "primary--text" },
                                          [
                                            _c("profile-table-loader", {
                                              attrs: { "loader-type": "column" }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "primary--text" },
                                          [
                                            _c("profile-table-loader", {
                                              attrs: { "loader-type": "column" }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "primary--text" },
                                          [
                                            _c("profile-table-loader", {
                                              attrs: { "loader-type": "column" }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                  _vm._v(" "),
                                  !_vm.coTableLoader
                                    ? _c(
                                        "td",
                                        { staticClass: "primary--text px-0" },
                                        [
                                          _vm.dtHoveredMember === props.item.id
                                            ? _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    "pr-4": "",
                                                    "justify-end": ""
                                                  }
                                                },
                                                [
                                                  _vm.displayEditMember(
                                                    props.item
                                                  ) ||
                                                  _vm.displayEditExternalMember(
                                                    props.item
                                                  )
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "pr-2 primary--text__action pa-0 ma-0",
                                                          attrs: {
                                                            text: "",
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.handleEditMember(
                                                                props.item.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "pr-1",
                                                              attrs: {
                                                                small: ""
                                                              }
                                                            },
                                                            [_vm._v("edit")]
                                                          ),
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  _vm.lblSetting
                                                                    .profileEdit
                                                                )
                                                              ) +
                                                              "\n                          "
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.$route.meta[
                                                    "edit_team_account"
                                                  ] &&
                                                  _vm.$route.meta[
                                                    "delete_team_account"
                                                  ]
                                                    ? _c(
                                                        "span",
                                                        { staticClass: "mt-2" },
                                                        [_vm._v("|")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.$route.meta[
                                                    "delete_team_account"
                                                  ] ||
                                                  (_vm.$route.meta[
                                                    "manage_external_account"
                                                  ] &&
                                                    _vm.displayEditExternalMember(
                                                      props.item
                                                    ))
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "primary--text__action pl-2 px-0 pr-0 ma-0",
                                                          attrs: {
                                                            text: "",
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.handleDeleteMembre2(
                                                                props.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "pr-1",
                                                              attrs: {
                                                                small: ""
                                                              }
                                                            },
                                                            [_vm._v("delete")]
                                                          ),
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  _vm.lblSetting
                                                                    .profileDelete
                                                                )
                                                              ) +
                                                              "\n                          "
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _c("v-layout", {
                                                staticStyle: { width: "15vw" }
                                              })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t(_vm.lblSetting.profileTableNoData)) +
                            "\n                  "
                        )
                      ]
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.dtMessageErrorModel
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleCloseErrorModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenDeleteMessage
        ? _c("base-delete-dialog", {
            attrs: {
              "is-loading": _vm.dtIsLoading,
              message: _vm.coProfileDelectionMessage
            },
            on: { cancel: _vm.handleDeleteCancel, delete: _vm.handleDeleteOK }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "60%" },
          model: {
            value: _vm.deleteDialog,
            callback: function($$v) {
              _vm.deleteDialog = $$v
            },
            expression: "deleteDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-flex",
                    {
                      staticClass:
                        "primary--text pa-0 mr-1 ml-1 modal-title--icon",
                      attrs: { "d-flex": "", xs1: "" }
                    },
                    [
                      _c("v-icon", { attrs: { large: "", color: "primary" } }, [
                        _vm._v("person_remove")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "headline ml-2 primary--text modal-title--text is-dark"
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t(_vm.lblSetting.deleteMembreModalTitle))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", icon: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleCancelDeleteMemebre($event)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("icon-close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.isMemberDeleted
                ? _c(
                    "div",
                    [
                      _c("v-card-text", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(_vm.lblSetting.deleteMembreConfirmMessage)
                          )
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("v-card-text", {
                        domProps: {
                          innerHTML: _vm._s(_vm.confirmationDeleteMessage)
                        }
                      }),
                      _vm._v(" "),
                      _vm.$route.meta["replace_team_account"] &&
                      _vm.$route.name === "team-management"
                        ? _c(
                            "v-card-text",
                            [
                              _c(
                                "base-control-label-vertical",
                                {
                                  attrs: { label: "Sélectionner un remplaçant" }
                                },
                                [
                                  _c("base-multi-select", {
                                    attrs: {
                                      rules: [],
                                      "item-value": "id",
                                      "item-text": "fullname",
                                      "return-object": false,
                                      options: _vm.replacementMembers,
                                      fetch: _vm.searchReplacementMembers,
                                      multiple: false
                                    },
                                    model: {
                                      value: _vm.dtReplacementMembers,
                                      callback: function($$v) {
                                        _vm.dtReplacementMembers = $$v
                                      },
                                      expression: "dtReplacementMembers"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _vm.isMemberDeleted
                ? _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "font-weight-bold primary--text",
                          attrs: { color: "turquoise", round: "" },
                          on: { click: _vm.handleCancelDeleteMemebre }
                        },
                        [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.btnOK)))]
                      )
                    ],
                    1
                  )
                : _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "greyDarker", flat: "" },
                          on: { click: _vm.handleCancelDeleteMemebre }
                        },
                        [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.btnCancel)))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "font-weight-bold primary--text",
                          attrs: {
                            color: "turquoise",
                            round: "",
                            loading: _vm.loadingDelete,
                            disabled: _vm.loadingDelete
                          },
                          on: { click: _vm.deleteAndReplaceMembre }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t(_vm.lblSetting.btnDeleteConfirm))
                          )
                        ]
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed88091c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed88091c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/team-management/template.html
// module id = null
// module chunks = 